export default __webpack_public_path__ + "static/media/bc-rmap-minus.afeb7407.svg";